/**
 * Payment Checkout Modal
 * 
 * Thin wrapper around CheckoutForm displayed as a modal overlay.
 * Kept for backward compatibility with the Pricing page.
 * For dedicated plan pages, use CheckoutForm directly.
 */
import React from 'react';
import { X } from 'lucide-react';
import CheckoutForm from './CheckoutForm';

const PaymentCheckoutModal = ({ 
  isOpen, 
  onClose, 
  plan,
  onSuccess,
  initialCouponCode = '',
  couponTargetPlanId = null
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto m-4">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center rounded-t-2xl z-10">
          <h2 className="text-xl font-bold text-gray-900">
            Complete Your Details & Purchase
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>
        
        {/* Content */}
        <div className="p-6">
          <CheckoutForm
            plan={plan}
            onSuccess={onSuccess}
            initialCouponCode={initialCouponCode}
            couponTargetPlanId={couponTargetPlanId}
            variant="modal"
            onClose={onClose}
          />
        </div>
        
        {/* Footer */}
        <div className="sticky bottom-0 bg-gray-50 border-t px-6 py-4 rounded-b-2xl">
          <button
            onClick={onClose}
            className="w-full px-6 py-3 bg-yellow-400 text-gray-900 rounded-full font-semibold hover:bg-yellow-500 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCheckoutModal;
